import PropTypes from 'prop-types';

export const AttendeeGroupProps = PropTypes.shape({
  name: PropTypes.string,
  description: PropTypes.string,
  attendee_min: PropTypes.number,
  attendee_max: PropTypes.number,
  price_per_attendee: PropTypes.number,
  price_min: PropTypes.number,
  price_max: PropTypes.number
});

export const AttendeeGroupDefaults = {
  name: '',
  description: '',
  attendee_min: 0,
  attendee_max: 0,
  price_per_attendee: 0,
  price_min: 0,
  price_max: 0
};

export const AttendeeGroupsProps = PropTypes.objectOf(AttendeeGroupProps);

export const AttendeeGroupsDefaults = {};
